import ChartEvent from '../chart-events/chart-event'
import ElementModel from '../models/element'
import Pane from './pane'

class ChartEventElement extends ElementModel {
  static initClass(paneModel: typeof Pane) {
    this.configure('ChartEventElement', 'instance', 'lastChange', 'zIndex', 'yIndex', 'elementId')
    this.belongsTo('pane', paneModel)
  }

  declare instance: ChartEvent
  yIndex = 0

  getChartEventData() {
    return this.instance.model
      .chart()
      .quote()
      ?.chartEvents?.find((stockEvent) => stockEvent.elementId === this?.elementId)
  }

  toObject() {
    return {
      ...super.toObject(),
      yIndex: this.yIndex,
    }
  }

  toConfig() {
    return {
      ...super.toConfig(),
      yIndex: this.yIndex,
    }
  }
}

export default ChartEventElement
